import type { AwsBody } from '@uppy/aws-s3';
import type { Meta, UppyFile } from '@uppy/core';

interface FileData {
  id?: string;
  metadata: {
    filename: string;
    mime_type?: string;
    size: number;
  };
  storage: string;
}

export const formatFileData = (file: UppyFile<Meta, AwsBody>): FileData => ({
  /** @see https://uppy.io/docs/aws-s3/#use-with-typescript */
  id: file.response?.body?.key,
  storage: 'store',
  metadata: {
    size: file.size ?? 0,
    filename: file.name ?? '',
    mime_type: file.type,
  },
});
